import React, { useEffect, useState } from 'react';
import { Box, makeStyles, Typography, useTheme } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import {
  AKADEMY_SCHOOLS_ROUTE,
  AKADEMY_USERS_ROUTE,
  AKADEMY_SCHOOL_MEMBERS_ROUTE,
  AKADEMY_CLASSES_ROUTE,
  AKADEMY_LANGUAGES_ROUTE,
  AKADEMY_CURRICULUM_FRAMEWORKS_ROUTE,
  AKADEMY_CURRICULUM_NODES_ROUTE,
  AKADEMY_CURRICULUM_AGE_GROUPS_ROUTE,
  AKADEMY_CURRICULUM_RATING_SCALES_ROUTE,
  AKADEMY_CURRICULUM_SUGGESTIONS_ROUTE,
  AKADEMY_INDICATOR_STATUTORIES_ROUTE,
  AKADEMY_STORAGE_PLAN_ROUTE,
  AKADEMY_Token_PLAN_ROUTE,
  AKADEMY_TALKTIME_PLANS_ROUTE,
  AKADEMY_TALKTIME_CONSUMPTION_ROUTE,
  AKADEMY_AI_ASSIST_CONSUMPTION_ROUTE,
  AKADEMY_WIDGET_ROUTE,
  AKADEMY_WIDGET_CUSTOMIZATION_ROUTE,
  AKADEMY_ANALYTICS_ROUTE,
} from '../../routes/routes';

const linkStyle = {
  height: 64,
  paddingLeft: 16,
  paddingRight: 16,
  marginTop: 8,
  marginBottom: 8,
  borderRadius: 4,
};

const useStyles = makeStyles((theme) => ({
  overAll: { paddingLeft: 5, paddingRight: 5 }, // 438
  linkStyle: {
    ...linkStyle,
  },
  linkStyleActive: {
    ...linkStyle,
    backgroundColor: theme.palette.buzzActiveLinkBackground,
  },
  textStyle: {
    textDecoration: 'none',
  },
}));

const isActiveRoute = (routeName, pathName) => {
  return routeName.includes(pathName);
};

const AkademySideNavBar = () => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const theme = useTheme();

  const initialPaths = [
    {
      name: 'Schools',
      link: AKADEMY_SCHOOLS_ROUTE,
    },
    {
      name: 'Users',
      link: AKADEMY_USERS_ROUTE,
    },
    {
      name: 'School Members',
      link: AKADEMY_SCHOOL_MEMBERS_ROUTE,
    },
    {
      name: 'Configurations',
      links: [
        {
          name: 'Classes',
          link: AKADEMY_CLASSES_ROUTE,
        },
        {
          name: 'Languages',
          link: AKADEMY_LANGUAGES_ROUTE,
        },
      ],
    },
    {
      name: 'Products & Subscriptions',
      links: [
        {
          name: 'Buddy Talktime Plans',
          link: AKADEMY_TALKTIME_PLANS_ROUTE,
        },
        { name: 'Storage Plan', link: AKADEMY_STORAGE_PLAN_ROUTE },
        { name: 'Token Plan', link: AKADEMY_Token_PLAN_ROUTE },
      ],
    },
    {
      name: 'AI Usage Tracking',
      links: [
        {
          name: 'Conversational Buddy',
          link: AKADEMY_TALKTIME_CONSUMPTION_ROUTE,
        },
        {
          name: 'AI Assist',
          link: AKADEMY_AI_ASSIST_CONSUMPTION_ROUTE,
        },
      ],
    },
    {
      name: 'Curriculum',
      links: [
        {
          name: 'Frameworks',
          link: AKADEMY_CURRICULUM_FRAMEWORKS_ROUTE,
        },
        {
          name: 'Framework Nodes',
          link: AKADEMY_CURRICULUM_NODES_ROUTE,
        },
        {
          name: 'Rating Scales',
          link: AKADEMY_CURRICULUM_RATING_SCALES_ROUTE,
        },
        {
          name: 'Age Groups',
          link: AKADEMY_CURRICULUM_AGE_GROUPS_ROUTE,
        },
        {
          name: 'Action Suggestions',
          link: AKADEMY_CURRICULUM_SUGGESTIONS_ROUTE,
        },
        {
          name: 'Statutories (v1)',
          link: AKADEMY_INDICATOR_STATUTORIES_ROUTE,
        },
      ],
    },
    {
      name: 'Widget',
      links: [
        {
          name: 'Widget Setup',
          link: AKADEMY_WIDGET_ROUTE,
        },
        {
          name: 'Customizing Branding',
          link: AKADEMY_WIDGET_CUSTOMIZATION_ROUTE,
        },
      ],
    },
    {
      name: 'Analytics',
      link: AKADEMY_ANALYTICS_ROUTE,
    },
  ];

  const [selectedPaths, setSelectedPaths] = useState(initialPaths);
  const [isShowingNestedPath, setIsShowingNestedPath] = useState(false);

  useEffect(() => {
    initialPaths.map(({ links }) => {
      if (
        links &&
        isActiveRoute(
          links.map(({ link }) => link),
          pathname
        )
      ) {
        setSelectedPaths(links);
        setIsShowingNestedPath(true);
      }
    });
  }, []);

  return (
    <Box
      flex={2}
      mr={3}
      border={1}
      borderColor={theme.palette.buzzBorder}
      borderRadius={4}
      className={classes.overAll}>
      {isShowingNestedPath && (
        <Box
          onClick={() => {
            setSelectedPaths(initialPaths);
            setIsShowingNestedPath(false);
          }}
          className={classes.linkStyleActive}
          display="flex"
          alignItems="center"
          style={{ cursor: 'pointer' }}>
          <ChevronLeftIcon color="primary" />
          <Box flexGrow={1}>
            <Typography color="textPrimary" component="div">
              <Box fontWeight={'fontWeightMedium'}>{'Back'}</Box>
            </Typography>
          </Box>
        </Box>
      )}

      {selectedPaths.map((path) => {
        const isActive = isActiveRoute(
          path.link || path.links.map(({ link }) => link),
          pathname
        );
        return (
          <Link
            key={path.name}
            to={path.link ? path.link : path.links[0].link}
            color="inherit"
            className={classes.textStyle}>
            <Box
              onClick={() => {
                if (path.link) return;

                setSelectedPaths(path.links);
                setIsShowingNestedPath(true);
              }}
              className={isActive ? classes.linkStyleActive : classes.linkStyle}
              display="flex"
              alignItems="center">
              <Box flexGrow={1}>
                <Typography color="textPrimary" component="div">
                  <Box fontWeight={isActive ? 'fontWeightMedium' : ''}>
                    {path.name}
                  </Box>
                </Typography>
              </Box>
              {isActive && <ChevronRightIcon color="primary" />}
            </Box>
          </Link>
        );
      })}
    </Box>
  );
};

export default AkademySideNavBar;
